import { css } from "@emotion/css";
import { FontSizeInPx, FontWeight, Spacing } from "@snapchat/snap-design-system";

export const checkbox = css`
    display: flex;

    margin: ${Spacing.MD}px ${Spacing.LG}px ${Spacing.LG}px;

    font-size: ${FontSizeInPx.REGULAR}px;
    font-weight: ${FontWeight.NORMAL};
    line-height: 20px;
    text-align: left;
`;
